import { render, staticRenderFns } from "./UserWorkfields.vue?vue&type=template&id=1924f746"
import script from "./UserWorkfields.vue?vue&type=script&lang=js"
export * from "./UserWorkfields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports